module.exports = __webpack_public_path__ + "img/statistics.e7222053.svg";